/* eslint-disable max-classes-per-file */
import Tabulator from 'tabulator-tables';

/* globals Knitiv */

/**
 * @typedef {Object} Column
 * @property {string} title
 */

/**
 * @typedef {Array<Column>} Columns
 */

/** @type {import('angular').IController} */
class TableController {
	/* @ngInject */
	/**
	 * @param {import('angular').IRootElementService} $element
	 * @param {any} $scope
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {import('angular').ITimeoutService} $timeout
	 */
	constructor(
		$element,
		$scope,
		$rootScope,
		$timeout,
	) {
		this.$element = $element;
		this.$scope = $scope;
		this.$rootScope = $rootScope;
		this.$timeout = $timeout;

		this.bordered = undefined;

		/** @type {?Tabulator} */
		this.table = null;

		this.isLoading = false;
		this.isReady = false;

		/** @type {Columns} */
		this.columns = [];

		/** @type {any[]} */
		this.data = [];

		/** @type {Tabulator.Options} */
		this.options = {};

		this.onBuilding = () => {};
		this.onDataLoaded = () => {};
		this.onReady = () => {};
	}

	setup() {
		this.options ??= {};

		const element = this.$element.find('.data-table').get(0);

		const fr = {
			ajax: {
				loading: 'Chargement',
				error: 'Erreur',
			},
			pagination: {
				page_size: 'Éléments par page',
				page_title: 'Afficher la page',
				first: 'Début',
				first_title: 'Premiere page',
				last: 'Fin',
				last_title: 'Derniere page',
				prev: 'Préc.',
				prev_title: 'Page précédente',
				next: 'Suiv.',
				next_title: 'Page suivante',
				all: 'Tout',
			},
		};

		const options = {
			clipboardPasteAction: undefined,
			dataLoaded: () => {
				this.$timeout(() => {
					this.onDataLoaded();
				});
			},
			locale: true,
			langs: {
				'K_NODE;FRANCAIS': fr,
				fr,
			},
			maxHeight: '100%',
			tableBuilding: this.onBuilding,
			tableBuilt: () => {
				this.$timeout(() => {
					this.isReady = true;
					this.onReady();
				});
			},
			...this.options,
		};

		if (element) {
			// setup() est rejoué à chaque changement d'`options` : sans cela, la table
			// précédente resterait dans le registre global de Tabulator.
			this.destroyTable();

			this.table = new Tabulator(element, options);

			this.$scope.$on('changeLanguage', (
				/** @type {any} */ event,
				/** @type {{id: string}} */ { id },
			) => {
				this.table?.setLocale(id);
			});
		}
		// @ts-ignore
		this.table?.setLocale(this.$rootScope.appConfig.lang.code);

		if (this.columns?.length > 0) {
			this.updateColumns();
		}
		if (this.data?.length > 0) {
			this.updateData();
		}
	}

	updateColumns() {
		this.columns ??= [];
		this.table?.setColumns(this.columns);
	}

	updateData() {
		this.data ??= [];
		this.table?.replaceData(this.data);
	}

	// eslint-disable-next-line class-methods-use-this
	/**
	 * @param {import('angular').IOnChangesObject} changes
	 */
	$onChanges(changes) {
		if (this.table) {
			if (changes.columns?.currentValue) {
				// this.updateColumns();
			}

			if (changes.data?.currentValue) {
				// this.updateData();
			}
		}

		if (changes.options?.currentValue) {
			this.setup();
		}
	}

	// eslint-disable-next-line class-methods-use-this
	$onInit() {
		if (this.rounded === undefined) {
			this.rounded = true;
		}
	}

	/**
	 * Tabulator s'inscrit dans un registre statique global
	 * (`Tabulator.prototype.comms.tables`) dont seul `destroy()` le retire. Sans
	 * cet appel, chaque table construite reste vivante pour toute la durée de
	 * l'onglet — avec ses lignes, ses colonnes et son DOM —, et ses bindings de
	 * redimensionnement comme ses raccourcis clavier continuent de répondre.
	 */
	destroyTable() {
		if (!this.table) {
			return;
		}

		try {
			this.table.destroy();
		}
		catch (error) {
			// Le DOM peut déjà avoir été démonté : ne pas laisser une erreur de
			// nettoyage interrompre la destruction du composant.
			console.error('kdatatable: échec de la destruction de la table', error);
		}

		this.table = null;
	}

	$onDestroy() {
		this.destroyTable();
	}
}

export default TableController;
